<ng-container *ngIf="page">
  <ng-container *ngIf="brConfig?.fundId; else previewBlock">
    <div *ngIf="!isSiteIntl" edsSpacing="md">
      <div edsSubGrid="layout-1" edsSubGridGap="lg">
        <ft-distribution-schedules
          [schedules]="schedules"
        ></ft-distribution-schedules>
        <ft-rates-and-yields
          *ngIf="showRatesAndYieldsSection && !hideRatesAndYieldsPerFund"
          [salesChargeBreakPoints]="salesChargeBreakPoints"
          [yields]="yields"
          [productType]="productType"
          [fundId]="brConfig.fundId"
          [navDate]="latestConfig?.navDate"
        ></ft-rates-and-yields>
      </div>
    </div>

    <div
      *ngIf="latestConfig?.asOfDate && !hideDistributionPerShare"
      edsSpacing="md"
    >
      <ft-distribution-latest
        [productType]="productType"
        [latestConfig]="latestConfig"
        [fundId]="brConfig.fundId"
        [isSiteIntl]="isSiteIntl"
        [latestDistributions]="latestDistributions"
        [displayCapGainRecords]="displayCapGainRecords"
      ></ft-distribution-latest>
    </div>

    <div
      *ngIf="tableConfig?.dividendYears.length > 0 && !hideDistributionPerShare"
      edsSpacing="md"
    >
      <eds-accordion>
        <eds-accordion-item
          [title]="
            'products.distribution-view-historical-distributions-data'
              | translate: brConfig.fundId
          "
          [expanded]="
            (!latestDistributions.length && !isSiteIntl) ||
            (isSiteIntl && !latestConfig?.asOfDate)
          "
        >
          <ft-distribution-historical
            [productType]="productType"
            [tableConfig]="tableConfig"
            [latestConfig]="latestConfig"
            [filteredHistoricalList]="filteredHistoricalList"
            [historicalTableTotalPages]="historicalTableTotalPages"
            [fundId]="brConfig.fundId"
            [isSiteIntl]="isSiteIntl"
            [configurationName]="componentConfiguration?.configurationName"
            (selectedYear)="updateDistributionHistoryTable($event)"
            (selectedPage)="onPageChanged($event)"
            (downloadAction)="onDownloadButtonClicked()"
          ></ft-distribution-historical>
        </eds-accordion-item>
      </eds-accordion>
    </div>
    <eds-proximal placement="DividendsProximalBottom"></eds-proximal>
  </ng-container>
</ng-container>

<ng-template #previewBlock>
  <h5>Distribution</h5>
</ng-template>
